import { Injectable, Optional } from '@angular/core';

export class AuthServiceConfig {
    isAuthenticated = false;
}


@Injectable()
export class AuthService {

    public isAuthenticated;
    public salutation;
    public email;
    public name: string;

    constructor( @Optional() config: AuthServiceConfig) {
        if (config) { this.isAuthenticated = config.isAuthenticated; }
    }



}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts